export default {
  '报表类型': '報表類型',
  '方案配置': '方案配置',
  '添加方案': '添加方案',
  '将报表方案配置至相应设备类型': '將報表方案配置至相應設備類型',
  '手机/平板': '手機/平板',
  '电脑': '電腦',
  '剩余可用字段': '剩余可用字段',
  '当前使用字段': '當前使用字段',
  '可长按拖动排序': '可長按拖動排序',
  '基础': '基礎',
  '提示': '提示',
  '取消': '取消',
  '确定': '確定',
  '重命名': '重命名',
  '请输入方案名': '請輸入方案名',
  '当前方案正在使用中，无法删除！': '當前方案正在使用中，無法刪除！',
  '确认删除该方案吗？': '確認刪除該方案嗎？',
  '确认将该方案应用于电脑端吗？': '確認將該方案應用於電腦端嗎？',
  '确认将该方案应用于手机/平板端吗？': '確認將該方案應用於手機/平板端嗎？',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': '未保存方案的情況下退出會丟失已操作的記錄。確認退出嗎?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存',
  '确定删除后会刷新页面，请确认右侧字段已保存': '確定刪除後會刷新頁面，請確認右側字段已保存',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': '未保存方案的情況下退出會丟失已操作的記錄。確認退出嗎？',
  '确定命名后会刷新页面，请确认右侧字段已保存': '確定命名後會刷新頁面，請確認右側字段已保存',
  '确定应用后会刷新页面，请确认右侧字段已保存': '確定應用後會刷新頁面，請確認右側字段已保存',
  '报表方案配置': '報表方案配置',
  '方案保存成功': '方案保存成功',
  '方案重命名成功': '方案重命名成功',
  '设备类型激活成功': '設備類型激活成功',
  '删除方案成功': '刪除方案成功',
  '添加成功': '添加成功',
  '保存': '保存'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/report.js